module.exports = __webpack_public_path__ + "static/media/car_how_to_rent.a7ce3403.png";